// reCAPTCHA configuration
// In development, set DISABLE_RECAPTCHA=true to skip reCAPTCHA checks
const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_DISABLE_RECAPTCHA === 'true';

export const RECAPTCHA_CONFIG = {
  // You'll need to get these from Google reCAPTCHA Console
  // https://www.google.com/recaptcha/admin
  SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  SECRET_KEY: process.env.REACT_APP_RECAPTCHA_SECRET_KEY,
  
  // Disable reCAPTCHA in development
  DISABLED: isDevelopment,
  
  // reCAPTCHA v3 actions
  ACTIONS: {
    LOGIN: 'login',
    REGISTER: 'register',
    FORGOT_PASSWORD: 'forgot_password',
    RESET_PASSWORD: 'reset_password'
  },
  
  // Minimum score threshold (0.0 to 1.0)
  MIN_SCORE: 0.5
};

export default RECAPTCHA_CONFIG;